import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo } from '@/store/slices/userInfo.js';

import logo from '@/assets/LOGO.svg';
import Icon from '@/components/iconfont/Icon.jsx';
import './index.less';
import { authService } from '@/api/index';
import { setToken } from '@/utils/cookie.js';
import message from '@/utils/message.jsx';

export default function SetPassword({ setCurrentPage, setLoginFlag, setUserDetailUpdate }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordFlag, setPasswordFlag] = useState(false);
  const [passwordAgainFlag, setPasswordAgainFlag] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [passwordCheck, setPasswordCheck] = useState(false);
  const [passwordAgainCheck, setPasswordAgainCheck] = useState(false);
  const [warningText, setWarningText] = useState('');
  const [passwordMessageBoxFlag, setPasswordMessageBoxFlag] = useState(false);
  const [passwordNum, setPasswordNum] = useState(false);
  const [loading, setLoading] = useState(false);
  const stateUserInfo = useSelector((state) => state.userInfo);

  // 用户输入密码
  const handleInputPassword = (val) => {
    setPasswordCheck(false);
    setPasswordAgainCheck(false);
    setWarningText('');
    setPassword(val.target.value);
  };
  // 用户确认密码
  const handleInputPasswordAgain = (val) => {
    setPasswordCheck(false);
    setPasswordAgainCheck(false);
    setWarningText('');
    setPasswordAgain(val.target.value);
  };
  const togglePassword = () => {
    setPasswordFlag((passwordFlag) => !passwordFlag);
  };
  const togglePasswordAgain = () => {
    setPasswordAgainFlag((passwordAgainFlag) => !passwordAgainFlag);
  };
  //注册
  const handleSubmitPassword = async () => {
    console.log(stateUserInfo);

    if (!passwordNum) {
      console.log('message提醒 密码不足8位');
      setPasswordCheck(true);
      setPasswordAgainCheck(true);
      setWarningText('The password you entered does not meet the requirements');
      return;
    }
    if (password !== passwordAgain) {
      console.log('message提醒 密码不一致');
      setPasswordCheck(true);
      setPasswordAgainCheck(true);
      setWarningText('Please keep the password consistent');
      return;
    }
    if (password.length > 32 || passwordAgain.length > 32) {
      setPasswordCheck(true);
      setPasswordAgainCheck(true);
      setWarningText('The password you entered does not meet the requirements');
      return;
    }
    setLoading(true);
    if (stateUserInfo.userInfo.formpage === 'signup') {
      try {
        const res = await authService.authRegister({
          email: stateUserInfo.userInfo.email,
          captchaCode: stateUserInfo.userInfo.emailCode,
          password,
          utmParams: {
            source: sessionStorage.getItem('source'),
            campaign: sessionStorage.getItem('campaign'),
            term: sessionStorage.getItem('term'),
            ad: sessionStorage.getItem('ad'),
          },
        });
        if (res.code === 0) {
          window.onClickSignUp(stateUserInfo.userInfo.email);
          setToken(res.data.token);
          if (setCurrentPage) {
            setLoginFlag(false);
            setUserDetailUpdate(Date.now());
          } else {
            navigate('/home');
            window.onClickGATrackEvent('signup-mail-success');
          }

          dispatch(setUserInfo({ key: 'formpage', value: '' }));
        }
      } catch (error) {
        console.log(error);
        const err = JSON.parse(error);
        if (err.code === -3) {
          message.error('Email verification failed, please try again');
        } else {
          message.warning('Reset failed, please try again');
        }
      }
    } else if (stateUserInfo.userInfo.formpage === 'forgotPassword') {
      try {
        const res = await authService.authResetPassword({
          email: stateUserInfo.userInfo.email,
          captchaCode: stateUserInfo.userInfo.emailCode,
          newPassword: password,
        });
        if (res.code === 0) {
          if (setCurrentPage) {
            setCurrentPage('setPasswordSuccess');
          } else {
            navigate('/setpasswordsuccess');
          }

          dispatch(setUserInfo({ key: 'formpage', value: '' }));
        }
      } catch (error) {
        const err = JSON.parse(error);
        if (err.code === -3) {
          message.error('Email verification failed, please try again');
        } else {
          message.warning('Reset failed, please try again');
        }
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    if (password || passwordAgain) {
      setPasswordMessageBoxFlag(true);
    } else {
      setPasswordMessageBoxFlag(false);
    }
    if (password.length >= 8 && passwordAgain.length >= 8) {
      setPasswordNum(true);
    } else {
      setPasswordNum(false);
    }
  }, [password, passwordAgain]);

  // 添加回车键盘监听
  useEffect(() => {
    const handleEnterPress = (e) => {
      if (e.key === 'Enter') {
        handleSubmitPassword();
      }
    };

    document.addEventListener('keydown', handleEnterPress);

    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, passwordAgain]);
  return (
    <div className="setpasswordBox">
      <img src={logo} className="logo" alt="" />
      <div className="text">Set Password</div>
      <div className="warning_text">{(passwordCheck || passwordAgainCheck) && warningText}</div>
      <label
        className={`input input-bordered outline-none flex items-center gap-2 password_ipt ${passwordCheck ? 'input-error' : ''}`}>
        <input
          type={passwordFlag ? 'text' : 'password'}
          autoComplete="new-password"
          placeholder="New password"
          onInput={handleInputPassword}
          className="grow focus:outline-none"
        />
        <label className="swap">
          <input type="checkbox" onChange={togglePassword} />
          <div className="swap-on">
            <Icon name="icon-view" className="iconsvg" />
          </div>
          <div className="swap-off">
            <Icon name="icon-view-off" className="iconsvg" />
          </div>
        </label>
      </label>
      <label
        className={`input input-bordered outline-none flex items-center gap-2 password_ipt ${passwordAgainCheck ? 'input-error' : ''}`}>
        <input
          type={passwordAgainFlag ? 'text' : 'password'}
          autoComplete="new-password"
          placeholder="Type password again"
          onInput={handleInputPasswordAgain}
          className="grow focus:outline-none"
        />
        <label className="swap">
          <input type="checkbox" onChange={togglePasswordAgain} />
          <div className="swap-on">
            <Icon name="icon-view" className="iconsvg" />
          </div>
          <div className="swap-off">
            <Icon name="icon-view-off" className="iconsvg" />
          </div>
        </label>
      </label>
      {passwordMessageBoxFlag ? (
        <div className="password_message">
          <div className="text1">Password Requirements:</div>
          <div className={passwordNum ? 'text2 text2active' : ''}>
            <span className="dian"></span>At least 8 characters
          </div>
        </div>
      ) : (
        ''
      )}

      {/*  */}
      {loading ? (
        <button className="btn btn-primary continue_btn">
          <span className="loading loading-spinner loading-md"></span>
        </button>
      ) : (
        <button className="btn btn-primary continue_btn" onClick={handleSubmitPassword}>
          Continue
        </button>
      )}
    </div>
  );
}
